export function isDefined<T>(value: T | null | undefined): value is T {
  return typeof value !== 'undefined' && value !== null;
}

export function isNonEmptyArray<T>(value: T[] | T | null | undefined): value is T {
  return typeof value !== 'undefined' && value !== null && Array.isArray(value) && value.length > 0;
}
